import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Grid, Button, Input, Dropdown} from 'semantic-ui-react';
import {dealerOrderStatus, dealerOrderTypes} from '../../../common/constants/lists';
import {findUserAgency} from '../../../common/util/user';
import {Actions} from '../../../common/actions';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {parseDealers, parseAgencies} from '../../../common/util/options';
import {paths} from '../../../common/dictionaries/urls';
import TrackingSchedule from '../trackingSchedule';
import OrdersDetail from './detail';
import './management.scss';

class Management extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleSelectionChange = this.handleSelectionChange.bind(this);
    this.handleDealerChange = this.handleDealerChange.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.handleClear = this.handleClear.bind(this);
    this.handleDownload = this.handleDownload.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
  }

  componentDidMount() {
    const {permissions} = this.props;

    if (!hasAccessPermission(permissions, resources.DealerOrdersAdministration, scopes.Edit)) {
      this.props.navigateTo(paths.AccessDenied);
    }

    this.handleClear();
    this.props.fetchDealers('importers');
    this.props.getAllAgencies();
  }

  handleClear() {
    this.props.restoreDealerOrdersManagement();
  }

  handleSelectionChange(event, data) {
    this.props.editDealerOrdersManagementFilter(data.name, data.value);
  }

  handleDealerChange(event, data) {
    this.props.editDealerOrdersManagementFilter('agency', '');
    this.props.editDealerOrdersManagementFilter(data.name, data.value);
  }

  handleFilterChange(event, data) {
    this.props.editDealerOrdersManagementFilter(data.name, data.value.toUpperCase());
  }

  handleSearch() {
    const {userAgency, orderType, orderCode, user, partCode, status, dealer, agency} = this.props;
    const userDealer = userAgency.dealerID;
    if (!orderCode && !partCode && !status) {
      this.props.addMessageBoxError(
        'El código de repuesto o el código de pedido son requeridos si desea realizar la búsqueda de todos los estados'
      );
      return false;
    }
    this.props.getDealersOrdersList({
      orderType,
      orderCode,
      user,
      partCode,
      status,
      dealer,
      agency,
      userDealer,
    });
  }

  handleDownload() {
    const {userAgency, orderType, orderCode, user, partCode, status, dealer, agency} = this.props;
    const userDealer = userAgency.dealerID;
    if (!orderCode && !partCode && !status) {
      this.props.addMessageBoxError(
        'El código de repuesto o el código de pedido son requeridos si desea realizar la búsqueda de todos los estados'
      );
      return false;
    }
    this.props.downloadDealerOrderManagement({
      orderType,
      orderCode,
      user,
      partCode,
      status,
      dealer,
      agency,
      userDealer,
    });
  }

  blockFilter() {
    const {orderCode, partCode, status} = this.props;

    return !orderCode && !partCode && !status;
  }

  renderUserAgency() {
    const {userAgency} = this.props;

    if (!userAgency) {
      return null;
    }

    return (
      <div className='user-agency'>
        {userAgency.dealerName} | {userAgency.description}
      </div>
    );
  }

  render() {
    const {
      loading,
      loadingAgencies,
      downloading,
      dealers,
      agencies,
      user,
      dealer,
      agency,
      status,
      orderType,
      orderCode,
      partCode,
    } = this.props;

    return (
      <div className='dealer-orders-management'>
        <Card raised fluid className='management-header'>
          <Grid>
            <Grid.Row>
              <Grid.Column width='10'>
                <h2>Administración de Pedidos - Concesionarios</h2>
                {this.renderUserAgency()}
              </Grid.Column>
              <Grid.Column width='6' textAlign='right'>
                <Button secondary content='LIMPIAR' disabled={loading || downloading} onClick={this.handleClear} />
                <Button
                  primary
                  content='EXPORTAR A EXCEL'
                  disabled={loading || downloading}
                  onClick={this.handleDownload}
                />
                <Button primary content='BUSCAR' disabled={loading || downloading} onClick={this.handleSearch} />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width='4'>
                <label>
                  <strong>Tipo de Pedido</strong>
                </label>
                <Dropdown
                  fluid
                  selection
                  name='orderType'
                  options={dealerOrderTypes}
                  value={orderType}
                  onChange={this.handleSelectionChange}
                />
              </Grid.Column>
              <Grid.Column width='4'>
                <label>
                  <strong>Estado</strong>
                </label>
                <Dropdown
                  fluid
                  selection
                  name='status'
                  options={dealerOrderStatus}
                  value={status}
                  onChange={this.handleSelectionChange}
                />
              </Grid.Column>
              <Grid.Column width='4'>
                <label>
                  <strong>Número de Pedido</strong>
                </label>
                <Input fluid name='orderCode' maxLength='6' value={orderCode} onChange={this.handleFilterChange} />
              </Grid.Column>
              <Grid.Column width='4'>
                <label>
                  <strong>Código</strong>
                </label>
                <Input fluid name='partCode' maxLength='20' value={partCode} onChange={this.handleFilterChange} />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width='4'>
                <label>
                  <strong>Concesionario</strong>
                </label>
                <Dropdown
                  fluid
                  selection
                  name='dealer'
                  disabled={loadingAgencies || this.blockFilter()}
                  options={parseDealers(dealers)}
                  value={dealer}
                  onChange={this.handleDealerChange}
                />
              </Grid.Column>
              <Grid.Column width='4'>
                <label>
                  <strong>Agencia</strong>
                </label>
                <Dropdown
                  fluid
                  selection
                  name='agency'
                  disabled={loadingAgencies || !dealer || this.blockFilter()}
                  options={parseAgencies(agencies, dealer)}
                  value={agency}
                  onChange={this.handleSelectionChange}
                />
              </Grid.Column>
              <Grid.Column width='4'>
                <label>
                  <strong>Usuario</strong>
                </label>
                <Input
                  fluid
                  name='user'
                  maxLength='30'
                  value={user}
                  disabled={this.blockFilter()}
                  onChange={this.handleFilterChange}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card>
        <OrdersDetail />
        <TrackingSchedule parentProps={this.props} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const {dealerId, dealerAgency} = state.session;
  const {agencies, list} = state.dealer;
  const userAgency = findUserAgency(agencies, dealerId, dealerAgency);

  return {
    'permissions': state.session.permissions,
    'userAgency': userAgency || {},
    'loading': state.dealerOrdersManagement.loading,
    'loadingAgencies': state.dealer.loading || state.dealer.loadingAgencies,
    'dealers': list,
    'agencies': agencies,
    'downloading': state.dealerOrdersTracking.downloading,
    'dealer': state.dealerOrdersManagement.dealer,
    'agency': state.dealerOrdersManagement.agency,
    'orderType': state.dealerOrdersManagement.orderType,
    'status': state.dealerOrdersManagement.status,
    'user': state.dealerOrdersManagement.user,
    'partCode': state.dealerOrdersManagement.partCode,
    'orderCode': state.dealerOrdersManagement.orderCode,
  };
};

const {
  fetchDealers,
  getAllAgencies,
  getDealersOrdersList,
  downloadDealerOrderManagement,
  restoreDealerOrdersManagement,
  editDealerOrdersManagementFilter,
  navigateTo,
  addMessageBoxError,
} = Actions;

export default connect(mapStateToProps, {
  fetchDealers,
  getAllAgencies,
  getDealersOrdersList,
  downloadDealerOrderManagement,
  restoreDealerOrdersManagement,
  editDealerOrdersManagementFilter,
  navigateTo,
  addMessageBoxError,
})(Management);
